const carouselBannerTypes = [
  {
    label: 'Horizontal',
    value: 'horizontal',
  },
  {
    label: 'Quadrado',
    value: 'square',
  },
  {
    label: 'Vertical padrão',
    value: 'vertical',
  },
  {
    label: 'Vertical estreito',
    value: 'vertical_taller',
  },
];

export default carouselBannerTypes;
